import React from 'react';
import { InputWrapper } from '@components/searchable-dropdownlist/styled';
import { DropdownMenu } from '@3plearning/react-components';
import PropTypes from 'prop-types';

const ClassFilters = ({ classroomOptions, onClassroomChange, selectedClass }) => {
  /**
   * VARIABLES
   */
  const hasSingleClass = classroomOptions.length === 1;

  /**
   * RENDER
   */
  if (hasSingleClass) {
    return <InputWrapper type={'text'} value={classroomOptions[0].label} readOnly />;
  }

  return (
    <DropdownMenu
      options={classroomOptions}
      selectedOption={selectedClass || classroomOptions[0]}
      onSelectOption={onClassroomChange}
    />
  );
};

ClassFilters.propTypes = {
  classroomOptions: PropTypes.array,
  onClassroomChange: PropTypes.func,
  selectedClass: PropTypes.object
};

export default ClassFilters;



// WEBPACK FOOTER //
// ./components/class-group-filters/class-filters/index.js